import { initialState, RequestsState } from './selectors';
import * as actions from './actions';

export default (
  state: RequestsState = initialState,
  action: actions.RequestsAction,
) => {
  switch (action.type) {
    case actions.REQUESTS_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.REQUESTS_ACTIONS.SUCCEEDED: {
      const {
        payload: { requests },
      } = action as actions.RequestsSucceeded;
      return { ...state, requests, loading: false };
    }

    case actions.REQUESTS_ACTIONS.FAILED: {
      const { error } = action as actions.RequestsFailed;
      return { ...state, error, loading: false };
    }

    case actions.RELOAD_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Requests/services/reducer.ts